// Lightweight analytics wrapper.
// Sends the event to PostHog (if loaded) AND to Google Analytics via gtag,
// so conversions (e.g. Mobile CTA Call vs WhatsApp vs Quote) show up in GA reports.
export const track = (event, props = {}) => {
  try {
    if (typeof window === "undefined") return;
    if (window.posthog && window.posthog.capture) {
      window.posthog.capture(event, props);
    }
    if (typeof window.gtag === "function") {
      // GA expects snake_case event names; keep the human-readable one as event_label.
      const gaName = event.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
      window.gtag("event", gaName, {
        event_category: "engagement",
        event_label: event,
        ...props,
      });
    }
  } catch (e) {
    /* no-op */
  }
};

// Google Ads conversion labels
export const GADS_CONVERSIONS = {
  quote_submitted: "AW-18411257116/DwQECLfbze8cEJz6lctE",
  whatsapp_click:  "AW-18411257116/Z12QCJTu0-8cEJz6lctE",
  call_click:      "AW-18411257116/Pr-TCK6Yy-8cEJz6lctE",
};

// Fires a Google Ads conversion event. Fire-and-forget: if gtag isn't
// available or fails for any reason, this silently no-ops so the user's
// intended action (opening WhatsApp / phone dialer / form submit) is never
// blocked or delayed.
export const fireAdsConversion = (sendTo, extra = {}) => {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "conversion", { send_to: sendTo, ...extra });
  } catch (e) {
    /* no-op */
  }
};

// Capture referral / UTM source if available.
export const getReferralSource = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const utm = ["utm_source", "utm_medium", "utm_campaign"]
      .map((k) => (params.get(k) ? `${k}=${params.get(k)}` : null))
      .filter(Boolean)
      .join("&");
    if (utm) return utm;
    if (document.referrer) return document.referrer;
    return "direct";
  } catch (e) {
    return "direct";
  }
};

// Normalise + validate an Indian mobile number.
export const normalizeIndianMobile = (raw) => {
  const digits = (raw || "").replace(/[^\d]/g, "");
  let n = digits;
  if (n.startsWith("91") && n.length === 12) n = n.slice(2);
  if (n.startsWith("0") && n.length === 11) n = n.slice(1);
  return n;
};

export const isValidIndianMobile = (raw) => /^[6-9]\d{9}$/.test(normalizeIndianMobile(raw));
